module.exports = __webpack_public_path__ + "static/media/37.8555c08e.wav";